import { useTextTranslation } from "../../utils/useTextTranslation";
import React, { useContext, useEffect, useRef } from "react";

import RtukGeneralIcon from "../../assets/icons/svg/RtukGeneralIcon";
import localizationStrings from "../../statics/localization";
import RtukSevenAgeIcon from "../../assets/icons/svg/RtukSevenAgeIcon";
import RtukThirteenAgeIcon from "../../assets/icons/svg/RtukThirteenAgeIcon";
import RtukAgeIcon from "../../assets/icons/svg/RtukAgeIcon";
import Namespace from "../../assets/icons/svg/Namespace";
import { SessionContext } from "../../context/SessionContext";
import LiveIcon from "../../assets/icons/svg/LiveIcon";
import { fancyHourFormatter } from "../../utils/fancyHourFormatter";

const VerticalProgramListItem = ({
  program,
  onSelect,
  recordStatus = "-2",
  onToggleRecord
}) => {
  const translateText = useTextTranslation();
  const { setSelectedCutvProgram, selectedCutvProgram } =
    useContext(SessionContext);
  const programRef = useRef(null);

  const isTruthyFlag = (value) =>
    value === true || value === 1 || value === "1" || value === "true";

  const isCurrentProgram = isTruthyFlag(program?.current);
  const isWatchableProgram = isTruthyFlag(program?.watchable);
  const isRecordedProgram = ["1", "0", "999"].includes(String(recordStatus));

  useEffect(() => {
    const scrollContainer = document.getElementById("program-list-container");

    if (!scrollContainer || !programRef.current) return;
    const shouldScroll =
      selectedCutvProgram?.epgProgramId === program?.epgProgramId ||
      (!selectedCutvProgram && program?.current);

    if (shouldScroll) {
      scrollContainer.scrollTo(
        0,
        programRef.current.offsetTop - programRef.current.offsetHeight - 120
      );
    }
  }, [selectedCutvProgram]);

  const hoursData = fancyHourFormatter(program?.startTime, program?.endTime);

  return (
    <div
      ref={programRef}
      className={`program-row ${isCurrentProgram ? "is-current" : ""} ${
        isWatchableProgram ? "" : "previousprog"
      }`}
      onClick={(e) => {
        if (isWatchableProgram && !isCurrentProgram) {
          const resolvedCode =
            program?.epgProgramId ||
            program?.prevuecode ||
            program?.prevueCode ||
            program?.id;

          setSelectedCutvProgram({
            ...program,
            epgProgramId: program?.epgProgramId || resolvedCode,
            prevuecode: program?.prevuecode || resolvedCode,
            _clickNonce: Date.now() + Math.random()
          });
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          onSelect(program);
          console.log({ program });
        }
      }}
    >
      <div className="epg-info">
        <button
          type="button"
          className="title"
          title={isWatchableProgram ? localizationStrings.watch : null}
          style={{
            cursor: isWatchableProgram ? "pointer" : "not-allowed"
          }}
        >
          {translateText(program?.title)}
        </button>
        <div className="genre-passingtime">
          {/* {program?.category ? (
            <>
              <div className="genre">{program?.category} </div>
              <span style={{ margin: "0 5px" }}>-</span>
            </>
          ) : null} */}
          <div className="date">
            {hoursData?.startTimeString} - {hoursData?.endTimeString}
          </div>
          {/* <span style={{ margin: "0 5px" }}>→</span> */}
          {/* <div className="date">{hoursData?.endTimeString}</div> */}
          {/* <div className="passing-time"></div> */}
        </div>
      </div>
      <div className="image-icon-group">
        <div
          className="current-program-icon-box"
          aria-hidden={!isCurrentProgram}
          style={{
            opacity: isCurrentProgram ? "1" : "0"
          }}
        >
          <div className="current-program-play-dot"> • </div>
          <span className="current-program-play-text">
            {localizationStrings.live}
          </span>
        </div>
        <div
          className="box-namespace"
          onClick={(e) => {
            e.stopPropagation();
            onSelect(program);
          }}
        >
          {<Namespace />}
        </div>
        <button
          className={`record-toggle-button ${
            isRecordedProgram ? "recorded" : "not-recorded"
          }`}
          title={
            isRecordedProgram
              ? localizationStrings.deleteRecord
              : localizationStrings.record
          }
          onClick={(e) => {
            e.stopPropagation();
            onToggleRecord && onToggleRecord(program);
          }}
        >
          {isRecordedProgram
            ? localizationStrings.deleteRecord
            : localizationStrings.record}
        </button>
        <div className="rating">
          {program?.rating?.age === "G" ? (
            <RtukGeneralIcon />
          ) : program?.rating?.age === "7+" ? (
            <RtukSevenAgeIcon />
          ) : program?.rating?.age === "13+" ? (
            <RtukThirteenAgeIcon />
          ) : program?.rating?.age === "18+" ? (
            <RtukAgeIcon />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default VerticalProgramListItem;
